import script from "./StudentResultList.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentResultList.vue?vue&type=script&setup=true&lang=js"

export default script